// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPresetPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var DashboardPresetConstants = require('logic/data/Izenda.DashboardPresetConstants');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  const { flow } = require('lodash/fp');
  var MAX_COLS = 12;

  var PresetIcon = function(props) {
    var dashboardDetail = props.dashboardDetail;
    var preset = props.preset;
    var onClick = flow(dashboardDetail.readPreset.bind(dashboardDetail, preset), props.onClosing);
    var className = classnames('izenda-DashboardPresetPopup-Icon', preset.icon);

    return (
      <div title={preset.tooltip} className="izenda-DashboardPresetPopup-IconBox" onClick={onClick}>
        <div className={className} />
      </div>
    );
  };

  var DashboardPresetPopup = React.createClass({
    propTypes: {
      dashboardDetail: ObservablePropTypes.observableObject.isRequired
    },
    render: function() {
      var props = this.props;
      var dashboardDetail = props.dashboardDetail;
      var onClosing = this.onClosing;

      return (
        <Popup visible onClosing={onClosing} autoClose={false} type="none">
          <Popup.Header title={DashboardPresetConstants.POPUP_HEADER} />
          <Popup.Body className="izenda-DashboardPresetPopup">
            <GridLayout>
              <GridLayout.Row>
                <GridLayout.Col cols={MAX_COLS}>{DashboardPresetConstants.POPUP_TEXT}</GridLayout.Col>
              </GridLayout.Row>
              <GridLayout.Row>
                {DashboardPresetConstants.OPTIONS.map(function(preset, index) {
                  return (
                    <GridLayout.Col key={index} cols="4" xs="6">
                      <PresetIcon
                        key={preset.tooltip}
                        dashboardDetail={dashboardDetail}
                        preset={preset}
                        onClosing={onClosing}
                      />
                    </GridLayout.Col>
                  );
                })}
              </GridLayout.Row>
            </GridLayout>
          </Popup.Body>
        </Popup>
      );
    },

    /**
     * Handle when popup closing
     * @param  {Object} closeCallback function
     * @param  {Object} type of close button click
     */
    onClosing: function(closeCallback, type) {
      this.props.onReject();
    }
  });

  module.exports = connect()(DashboardPresetPopup);
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardPresetPopup/Izenda.DashboardPresetPopup.jsx